import { useMemo } from 'react';

import { InputGroup as TwyneInputGroup, InputGroupText, Select } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

import ToggleGroup from './ToggleGroup';

export default function OverflowProperty() {
  const { value, setValue } = useCraftProp('overflow.type')
  const { value: all, setValue: setAll } = useCraftProp('overflow.all')
  const { value: x, setValue: setX } = useCraftProp('overflow.x')
  const { value: y, setValue: setY } = useCraftProp('overflow.y')
  const type = useMemo(() => value || 'all', [value])

  const toggleOptions = [
    { value: 'all', tooltip: 'All', icon: 'all' },
    { value: 'axis', tooltip: 'Axis', icon: 'axis' },
  ]

  const handlerReset = value => {
    const setters = value === 'all' ? [setX, setY] : [setAll]
    setters.forEach(setter => setter(undefined))
  }

  const handleChangeType = value => {
    setAll(value)
    setValue('all')
  }

  return <>
    <div className='flex flex-col gap-1'>
      <div className='flex items-center gap-1'>
        <Select
          options={OPTIONS}
          value={type === 'all' && all}
          onChange={item => handleChangeType(item?.value)}
          variant='accent'
          disabled={type !== 'all'}
          clearable
        />
        <ToggleGroup
          name='overflow.type'
          options={toggleOptions}
          type='single'
          value={type}
          onChange={handlerReset}
        />
      </div>

      {type === 'axis' && <>
        <div className='flex gap-1 w-full'>
          <TwyneInputGroup variant='accent' className='w-full'>
            <InputGroupText addonType='prepend'>
              X
            </InputGroupText>
            <Select
              options={OPTIONS}
              value={x}
              onChange={item => setX(item?.value)}
              variant='accent'
              clearable
            />
          </TwyneInputGroup>
          <TwyneInputGroup variant='accent' className='w-full'>
            <InputGroupText addonType='prepend'>
              Y
            </InputGroupText>
            <Select
              options={OPTIONS}
              value={y}
              onChange={item => setY(item?.value)}
              variant='accent'
              clearable
            />
          </TwyneInputGroup>
        </div>
      </>}
    </div>
  </>
}

const OPTIONS = [
  { label: 'Auto', value: 'auto' },
  { label: 'Hidden', value: 'hidden' },
  { label: 'Clip', value: 'clip' },
  { label: 'Visible', value: 'visible' },
  { label: 'Scroll', value: 'scroll' },
]

